module.exports = __webpack_public_path__ + "static/media/contact-01.bcdbb1d8.png";